import axios from 'axios';
import { apiUrl } from '../../Global';

const instance = axios.create({
    baseURL: apiUrl
});

export default instance;